import React from 'react';

export const AppContext = React.createContext(undefined as any);

export function useAppContext() {
  return React.useContext(AppContext);
}
